import { call, put, takeEvery } from "redux-saga/effects";
import {  toast } from 'react-toastify';
import { GET_ADDVENDOR_FAILED, GET_ADDVENDOR_REQUESTED, GET_ADDVENDOR_SUCCESS, GET_UPDATEVENDOR_FAILED, GET_UPDATEVENDOR_REQUESTED, GET_UPDATEVENDOR_SUCCESS, GET_VENDOR_FAILED, GET_VENDOR_REQUESTED, GET_VENDOR_SUCCESS, GET_VENDORUSER_FAILED, GET_VENDORUSER_REQUESTED, GET_VENDORUSER_SUCCESS } from "resources/actionTypes";
import { addVendorApi, updateVendorApi, vendorApi, vendorUserApi } from "services/VendorService";
import { getVendor, getVendoruser } from "redux/actions/UserVendor";
import store from "redux/store";
import { fetchAdminUser } from "redux/actions/AdminUserAction";

function* fetchVendor(action) {
  try {
    const payload = action.payload || {}
    const userVendor = yield call(vendorApi,payload);
    yield put({ type: GET_VENDOR_SUCCESS, userVendor: userVendor });
  } catch (e) {
    yield put({ type: GET_VENDOR_FAILED, message: e.message });
  }
}

export function* vendorSaga() {
  yield takeEvery(GET_VENDOR_REQUESTED, fetchVendor);
}

function* fetchAddVendor(action) {
  const payload = action.payload || {}
  const userAddVendor = yield call(addVendorApi, payload.userAddVendor);
  if(userAddVendor.success){
    yield put({ type: GET_ADDVENDOR_SUCCESS, userAddVendor: userAddVendor });
    toast.success(userAddVendor.message);
    if(payload?.userAddVendor?.type){
      store.dispatch(fetchAdminUser())
    } else{
    store.dispatch(getVendoruser({id:payload?.userAddVendor?.id, search:""}));
    }
  }else{
    yield put({ type: GET_ADDVENDOR_FAILED, message: userAddVendor.message });
    toast.error(userAddVendor?.message || 'Add Vendor failed');
  }
}
export function* addVendorSaga() {
  yield takeEvery(GET_ADDVENDOR_REQUESTED, fetchAddVendor);

}

function* fetchUpdateVendor(action) {
  const payload = action.payload || {}
  const userUpdateVendor = yield call(updateVendorApi, payload.userUpdateVendor);
  if(userUpdateVendor.success){
    yield put({ type: GET_UPDATEVENDOR_SUCCESS, userUpdateVendor: userUpdateVendor });
    toast.success(userUpdateVendor.message);
    store.dispatch(getVendor(payload.userUpdateVendor.vendorId));
  }else{
    yield put({ type: GET_UPDATEVENDOR_FAILED, message: userUpdateVendor.message });
    toast.error(userUpdateVendor?.message || 'Update Vendor failed');
  }
}
export function* updateVendorSaga() {
  yield takeEvery(GET_UPDATEVENDOR_REQUESTED, fetchUpdateVendor);

}

function* fetchVendorUser(action) {
  try {
    const payload = action.payload || {}
    const userVendorUser = yield call(vendorUserApi,payload);
    yield put({ type: GET_VENDORUSER_SUCCESS, userVendorUser: userVendorUser });
  } catch (e) {
    yield put({ type: GET_VENDORUSER_FAILED, message: e.message });
  }
}

export function* vendorUserSaga() {
  yield takeEvery(GET_VENDORUSER_REQUESTED, fetchVendorUser);
}
